<template>
  <div>
    <!-- <div>
      <b-row align-h="start" class="mb-1">
        <b-form-checkbox size="sm">Small</b-form-checkbox>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-primary"
          size="sm"
          class=""
          @click="hideShowFilter"
        >
          {{ filtersHidden == true ? "Show Filters" : "Hide Filters" }}
        </b-button>
      </b-row>
    </div> -->
    <b-alert variant="secondary" show>
      <b-row cols="12" class="mb-1 alert-heading">
        <b-col class="d-flex align-items-center justify-content-between">
          <b-form-checkbox
            v-if="$props.isPaymentPage != 'Y'"
            @change="hideShowFilter"
            checked="true"
          >
            <b>show filters</b>
          </b-form-checkbox>

          <div class="d-flex align-items-center gap-1">
            <div class="d-flex align-items-center mr-2">
              <b-form-checkbox
                v-model="showDeletedRevenues"
                switch
                @change="getAllRevenueData"
                class="custom-blue-switch mr-1"
              />
              <label class="mb-0">Show Deleted Revenues</label>
            </div>

            <b-button
              v-if="$props.isPaymentPage != 'Y'"
              @click="onInputAdd"
              size="sm"
              variant="outline-primary"
            >
              show additional cost data
            </b-button>
          </div>

        </b-col>
      </b-row>
    </b-alert>

    <b-card
      no-body
      v-if="this.filtersHidden == false && $props.isPaymentPage != 'Y'"
    >
      <div>
        <div class="m-1">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col cols="12" md="12">
              <b-form @submit.prevent>
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Title">
                      <!-- @search="GetAllMovie" -->
                      <v-select
                        v-model="filterTempMovie"
                        placeholder="Title"
                        label="full_title"
                        :options="optionTempMovie"
                        @input="onFilterChange"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Licensee/Licensor/Contact">
                      <v-select
                        v-model="selectedCustomer"
                        placeholder="Licensee/Licensor/Contact"
                        label="company"
                        :options="optionCustomer"
                        @input="onFilterChange"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Rights">
                      <treeselect
                        :options="trl_rights"
                        multiple
                        placeholder="Rights"
                        v-model="subRights"
                        @input="onFilterChange"
                      />
                      <!-- :disabled="licenseBeginSelected" -->
                      <!-- <v-select
                        :closeOnSelect="false"
                        :reduce="(label) => label.lbl_id"
                        v-model="subRights"
                        multiple
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="sub_rights_list"
                        label="lbl_name"
                        value="lbl_id"
                        placeholder="Select Sub Rights"
                        @input="onFilterChange"
                      /> -->
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group label="Revenue Type">
                      <v-select
                        v-model="selectedRight"
                        placeholder="Revenue Type"
                        label="title"
                        :options="optionRights"
                        @input="onFilterChange"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group label="Revenue Status">
                      <v-select
                        v-model="selectedStatus"
                        placeholder="Revenue Status"
                        label="title"
                        :options="optionStatus"
                        @input="onFilterChange"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group label="Revenue Date Range">
                      <flat-pickr
                        :disabled="
                          selectedStatus && selectedStatus.value == '3'
                            ? true
                            : false
                        "
                        v-model="revenueDateRange"
                        placeholder="Revenue Date"
                        class="form-control"
                        :config="{
                          mode: 'range',
                          ...$flatPickrConfig,
                        }"
                        @input="onFilterChange"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Royalty Report Revenue">
                      <v-select
                        v-model="selectedRelevance"
                        placeholder="Royalty Report Revenue"
                        label="title"
                        :reduce="(r) => r.value"
                        :options="relevanceOptions"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    class="mt-1 d-flex flex-wrap align-items-center"
                    md="4"
                  >
                    <b-button
                      size="sm"
                      :disabled="
                        selectedStatus && selectedStatus.value == '3'
                          ? true
                          : false
                      "
                      @click="onSearch()"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="outline-info"
                      class="mr-1 mb-1"
                    >
                      Search
                    </b-button>
                    <b-button
                      size="sm"
                      @click="downloadCSV('normal')"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="outline-success"
                      class="mr-1 mb-1"
                    >
                      Export Revenue CSV
                    </b-button>
                    <!-- <b-button
                                            size="sm"
                                            @click="downloadCSV('bookkeeping')"
                                            v-ripple.400="
                                                'rgba(255, 255, 255, 0.15)'
                                            "
                                            type="submit"
                                            variant="outline-success"
                                            class="mr-1 mb-1"
                                        >
                                            Export Bookkeeping Revenue CSV
                                        </b-button> -->
                    <b-button
                      size="sm"
                      variant="outline-warning"
                      @click="resetForm"
                      class="mb-1 mr-1"
                    >
                      Reset
                    </b-button>
                    <!-- submit and reset -->
                    <!-- <div class="d-flex align-items-center mb-1">
                        <b-form-checkbox
                          v-model="showDeletedRevenues"
                          switch
                          @change="getAllRevenueData"
                          class="custom-blue-switch mr-1"
                        />
                         <b-form-group class="mt-2" label="Show Deleted Revenues"></b-form-group>
                      </div> -->
                    
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
    <!-- <b-card no-body> -->
    <b-form-checkbox
      switch
      inline
      class="mb-1"
      v-model="setPaymentDate"
      @change="toggleSetPaymentDate"
      v-if="$props.isPaymentPage == 'Y'"
    >
      Keep Payment Date Same For All Invoices
    </b-form-checkbox>
    <!-- </b-card> -->
    <b-card no-body>
      <b-table
        bordered
        v-if="$can('read', 'revenue')"
        ref="selectableTable"
        :fields="fields"
        :items="revenueDataList"
        responsive
        empty-text="No  records found"
        show-empty
        small
        hover
      >
        <template #head(sr)="data">
          <b-badge v-if="totalRows" variant="success">{{ totalRows }}</b-badge>
        </template>
        <template #cell(additionalDataViewAddRevenue)="data">
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <feather-icon
              style="cursor: pointer"
              icon="InfoIcon"
              size="23"
              @mouseenter="handleHover(data.item.revenue_data_id)"
              @mouseleave="handleHoverRelease()"
            />
          </div>
          <div v-if="hoverId === data.item.revenue_data_id">
            <hover-metadata-component
              :item="{
                ...data.item,
                createdAt: formatDate(data.item.createdAt),
                updatedAt: formatDate(data.item.updatedAt),
              }"
              :idField="'vendor_id'"
              :createdAt="data.item.createdAt"
              :createdBy="data.item.createdBy_name"
              :updatedAt="data.item.updatedAt"
              :updatedBy="data.item.updatedBy_name"
              :isHovered="hoverId === data.item.revenue_data_id"
              :showAbove="data.index >= itemsInRow - 3? true : false "
            />
          </div>
        </template>
        <template #cell(sr)="data">
          {{ data.index + 1 + (currentPage - 1) * limit }}
        </template>

        <template v-slot:cell(selected)="data">
          <b-form-checkbox
            v-if="setIsInvoice == true"
            v-model="selectedRevenueItems"
            :value="data.item"
          >
          </b-form-checkbox>
        </template>

        <template #cell(date)="data">
          <div class="text-nowrap" v-if="data.item.status != '100'">
            <span>
              Revenue Dt. :

              {{
                data.item.date
                  ? moment(data.item.date).format("DD/MM/YYYY")
                  : ""
              }}<br
            /></span>
            <span v-if="data.item.right_type == '2'">
              Royalty Dt. :
              <b>{{
                data.item.revenue_royalty_date
                  ? moment(data.item.revenue_royalty_date).format("DD/MM/YYYY")
                  : ""
              }}</b></span
            >
          </div>
          <div class="text-nowrap" v-if="data.item.status == '100'">
            <span>
              Revenue Dt. :
              <flat-pickr
                v-if="data.item.status == '100'"
                :config="{
                  ...$flatPickrConfig,
                }"
                placeholder="Revenue Date"
                class="form-control"
                v-model="data.item.date" />

              <span v-else>{{
                data.value ? moment(data.value).format("DD/MM/YYYY") : ""
              }}</span>
              <br
            /></span>
            <span>
              Royalty Dt. :
              <flat-pickr
                v-if="data.item.status == '100'"
                :config="{
                  ...$flatPickrConfig,
                }"
                placeholder="Royalty Date"
                class="form-control"
                v-model="data.item.revenue_royalty_date"
              />

              <span v-else>{{
                data.value ? moment(data.value).format("DD/MM/YYYY") : ""
              }}</span>
            </span>
          </div>
        </template>
        <template #cell(updatedAt)="data">
          {{ data.value ? moment(data.value).format("DD/MM/YYYY HH:mm") : "" }}
          <!-- <b-badge
            v-if="
              $can('create', 'expense') &&
              data.item.status != '100' &&
              $props.isPaymentPage != 'Y'
            "
            type="submit"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="danger"
            @click="showDeleteConfirm(data.item, 'delete')"
          >
            Delete
          </b-badge>

          <b-badge
            type="submit"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="success"
            v-else
            @click="
              () => {
                showModal('Are you sure want to revert?', 'save').then(
                  (value) => {
                    if (value) {
                      handle_revert(data.item);
                    }
                  }
                );
              }
            "
          >
            Revert
          </b-badge> -->

  <div class="text-nowrap">
    <!-- Show Revert if showDeletedRevenues is true -->
    <b-badge
      v-if="showDeletedRevenues && $can('update', 'add_revenues')"
      type="submit"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      size="sm"
      variant="success"
      @click="
        () => {
          showModal('Are you sure want to revert?', 'save').then((value) => {
            if (value) {
              handle_revert(data.item);
            }
          });
        }
      "
    >
      Revert
    </b-badge>

    <!-- Show Delete if showDeletedRevenues is false -->
    <b-badge
      v-else-if="
        $can('delete', 'add_revenues') &&
        data.item.status != '100' &&
        $props.isPaymentPage != 'Y'
      "
      type="submit"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      size="sm"
      variant="danger"
      @click="showDeleteConfirm(data.item, 'delete')"
    >
      Delete
    </b-badge>
  </div>

          <!-- <br /> -->
        </template>

       

        <template #cell(addmission)="data">
          {{
            data.item.right_type == "1" && data.item.addmission
              ? data.item.addmission
              : 0
          }}
        </template>
        <template #cell(unit_sold)="data">
          {{
            data.item.right_type == "2" && data.item.unit_sold
              ? data.item.unit_sold
              : 0
          }}
        </template>
        <template #cell(share_net)="data">
          <div
            class="text-nowrap"
            v-if="data.item.status != '100' || data.item.inv_number"
          >
            <b>
              {{
                data.item.right_type == "1"
                  ? "NA"
                  : formatCurrency(data.item.share_net)
              }}</b
            >
          </div>
          <div
            class="text-nowrap"
            v-if="data.item.status == '100' && !data.item.inv_number"
          >
            <b-form-input
              v-model="data.item.boNet"
              placeholder="BO Net"
              type="number"
              v-if="data.item.right_type == '1'"
            ></b-form-input>
            <b-form-input
              v-model="data.item.share_net"
              placeholder="Share Net"
              type="number"
              v-else
            >
            </b-form-input>
          </div>
        </template>
        <template #cell(rentalNet)="data">
          <b>{{
            data.item.right_type == "1"
              ? formatCurrency(data.item.rentalNet)
              : "NA"
          }}</b>
        </template>
        <template #cell(boNet)="data">
          <b>
            {{
              data.item.right_type == "1"
                ? formatCurrency(data.item.boNet)
                : "NA"
            }}</b
          >
        </template>

        <template #cell(title)="data">
          {{ data.item.uniqueId }}-
          {{ data.item.title }}
        </template>

        <template #cell(company)="data">
          <div class="text-nowrap">
            <span
              ><p>Lisensee : {{ data.item.company }}</p>
              <p>Licensor : {{ data.item.licensor_company }}</p></span
            >
          </div>
        </template>
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <span
              >Revenue Type:
              {{ data.item.right_type == "1" ? "Theatrical" : "Other" }}</span
            >
            <div v-if="data.item.is_billed == '1'">
              <b-badge v-if="data.item.inv_number" variant="light-primary">
                billed with #inv
                {{ data.item.inv_number
                }}{{
                  data.item.is_manual_invoice == 1 ? " (Manual)" : ""
                }}</b-badge
              >
              <b-badge v-else variant="light-primary"> Direct Billing</b-badge>
            </div>

            <div v-else><span>NA</span></div>
            <div v-if="$props.isPaymentPage == 'Y'" class="mt-1">
              <p>Payment Date</p>
              <flat-pickr
                v-if="$props.isPaymentPage == 'Y'"
                :config="{
                  ...$flatPickrConfig,
                }"
                v-model="data.item.revenue_payment_date"
                placeholder="Payment Date"
                class="form-control"
              />
              <b-button
                @click="showDeleteConfirm(data.item, 'update')"
                class="mt-1"
                size="sm"
                variant="primary"
                >Update</b-button
              >
            </div>
          </div>
        </template>
      </b-table>
      <template #footer>
        <div>
          <b-row>
            <b-col
              class="d-flex align-items-end justify-content-end justify-content-sm-center"
            >
              <b-pagination
                @change="onPageChange"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="limit"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                :limit="15"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BProgress,
  BBadge,
  BButton,
  BTooltip,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BDropdown,
  BDropdownItem,
  BFormFile,
  BAlert,
  BTabs,
  BTab,
  VBTooltip,
  BPagination,
  BFormRadio,
  BFormRadioGroup,
  BModal,
  BSpinner,
} from "bootstrap-vue";
import {
  GetVendorRevenueData,
  DeleteRevenueById,
} from "@/apiServices/RevenueServies";
import vSelect from "vue-select";
import moment from "moment";
import { getAllData } from "@/apiServices/MastersServices";
import { getAllVendor } from "@/apiServices/VendorServices";
import { getAllMovie } from "@/apiServices/MovieServices";
import * as MasterServices from "@/apiServices/MastersServices.js";
import Ripple from "vue-ripple-directive";
import { TokenService } from "@/apiServices/storageService";

import flatPickr from "vue-flatpickr-component";
import { downloadFromURL } from "@/utils/helpers";
import ToastificationContentVue from "@core/components/toastification/ToastificationContent.vue";
import { formatCurrency } from "@/utils/helpers";
import Treeselect from "@riophae/vue-treeselect";
import { debounce } from "@/utils/helpers";
import HoverMetadataComponent from "@/views/components/HoverMetadataComponent.vue";
import showModal from "../../../components/ModalConfirmation";
import * as RevenueServices from "@/apiServices/RevenueServies";

export default {
  props: {
    isPaymentPage: {
      type: String,
    },
    invNumber: {
      type: Number,
    },
    showModals: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BCard,
    BTable,
    BProgress,
    BBadge,
    vSelect,
    BButton,
    BTooltip,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormFile,
    BAlert,
    BBadge,
    flatPickr,
    BTabs,
    BTab,
    BFormRadio,
    VBTooltip,
    BPagination,
    ToastificationContentVue,
    BFormRadioGroup,
    Treeselect,
    HoverMetadataComponent,
    BModal,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      moment: moment,
      hoverId: null,
      BASE_URL: process.env.VUE_APP_BASEURL,
      stickyHeader: true,
      selectAllStatus: "0",
      filterTempTerritory: null,
      optionTempTerritory: [],
      sub_rights_list: [],
      subRights: [],
      filterTempRights: null,
      optionTempRights: [],
      filterTempMovie: null,
      optionTempMovie: [],
      revenueDateRange: null,
      selectedCustomer: null,
      selectedRight: null,
      optionCustomer: [],
      relevanceOptions: [
        { title: "All", value: null },
        { title: "Relevant For Royalty Report", value: 1 },
        { title: "Not Relevant For Royalty Report", value: 0 },
      ],
      optionRights: [
        { title: "Theatrical Rights", value: 1 },
        { title: "Other Rights", value: 2 },
      ],

      selectedStatus: null,
      selectedRelevance: 1,
      setIsInvoice: false,
      optionStatus: [
        { title: "Billed", value: 1 },
        { title: "Unbilled", value: 0 },
        // { title: "Generate Manual Invoice", value: 3 },
      ],
      moment: moment,
      currentPage: 1,
      totalPages: 0,
      limit: 25,
      totalRows: null,
      perPageOptions: [25, 50, 100],
      fields: [
        { key: "sr", label: "SR" },
        { key: "actions", label: "Actions" },
        //
        // { key: "selected", label: "" },
        // { key: "uniqueId", label: "Unique Id" },
        { key: "title", label: "Movie" },
        { key: "company", label: "Customer" },
        { key: "vatCode"  , label: "Accounting code"},

        { key: "rightIdentifier", label: "Rights" },
        { key: "mainTerritory", label: "Territory" },
        { key: "addmission", label: "Admissions" },
        { key: "unit_sold", label: "Unit Sold" },

        {
          key: "share_net",
          label: "Share Net (CHF)",
          class: "text-right",
          variant: "danger",
        },
        {
          key: "boNet",
          label: "Bo Net (CHF)",
          variant: "danger",
          class: "text-right",
        },
        {
          key: "rentalNet",
          label: "Rental Net (CHF)",
          variant: "danger",
          class: "text-right",
        },
        { key: "date", label: "Dates (DD/MM/YYYY)" },
        // { key: "revenue_royalty_date", label: "DATE FOR ROYALTY REPORT" },

        // { key: "unit_sold", label: "Unit Sold / Addmission" },

        // { key: "rentalNet", label: "RentalNet" },

        { key: "updatedAt", label: "Last Updated" },
        { key: "additionalDataViewAddRevenue", label: "Logs" },
      ],

      revenueDataList: [],
      revenueDataListAll: [],
      selectedRevenueItems: [],
      showGenerateInvoice: false,
      filtersHidden: false,
      selectedPage: "revenue",
      optionsPage: [
        { text: "Add Revenue List", value: "revenue" },
        { text: "Additional Cost List", value: "additional" },
      ],

      trl_rights: [],
      subRightsChildren: [],
      setPaymentDate: false,
      showDeletedRevenues: false,
      itemsInRow: 25,
    };
  },

  watch: {
    selectedRevenueItems() {
      if (this.selectedRevenueItems.length > 0) {
        if (this.selectedRevenueItems.length != this.revenueDataList.length) {
          this.selectAllStatus = "0";
        } else {
          this.selectAllStatus = "1";
        }
      } else {
      }
    },
  },
  async beforeMount() {
    this.loadAllRevenueData();
    this.getAllRevenueData();
    this.GetAllVendor();
    this.GetAllMovie();
    this.getAllRights();
    const response1 = await getAllData({
      master: "sub_right",
      deleted: "0",
    });
    if (response1.status == 200) {
      console.log(response1.data.data, "hh");
      this.sub_rights_list = response1.data.data.rows.filter((z) => {
        return z.lbl_value1 != "" && z.lbl_value1 != null;
      });
    }
  },
  methods: {
    showModal,
    formatDate(dateString) {
      console.log(dateString);
      if (!dateString) return "";
      if (
        dateString.startsWith("0000-00-00") ||
        !moment(dateString).isValid()
      ) {
        return "";
      } else {
        let val = moment(dateString).format("DD-MM-YYYY");
        console.log(val, "after-conversion");
        return val;
      }
    },
    handleHover(hoveringId) {
      console.log(hoveringId, "hoverId");
      this.hoverId = hoveringId;
    },
    handleHoverRelease() {
      this.hoverId = null;
    },
    onUpdateRevenuePaymentDate() {},
    onInputAdd() {
      this.$router.push("/additional-cost");
    },
    formatCurrency,

    downloadCSV(type) {
      try {
        const token = TokenService.getToken();

        if (!token) {
          alert("Error in getting token");
        }
        let payload = {
          invoice_number:
            this.$props && this.$props.invNumber ? this.$props.invNumber : null,
          vendor_id: this.selectedCustomer
            ? this.selectedCustomer.vendor_id
            : "",
          rightType: this.selectedRight ? this.selectedRight.value : "",
          billedStatus: this.selectedStatus ? this.selectedStatus.value : "",

          start_date: this.revenueDateRange
            ? this.revenueDateRange.split("to")[0]
            : "",
          end_date: this.revenueDateRange
            ? this.revenueDateRange.split("to")[1]
            : "",
          search: this.search,
          limit: this.limit,
          page: this.currentPage,
          movie_id:
            this.filterTempMovie && this.filterTempMovie.id
              ? this.filterTempMovie.id
              : null,
          subRights: this.subRights,
          relevant_for_royalty: this.selectedRelevance,
          reporttype: type,
        };

        let baseURL = `${process.env.VUE_APP_BASEURL}/revenue/sheet/download-vendor-revenue?authorization=${token}`;

        const urlStr = this.getURLString(baseURL, payload);

        console.log({ urlStr });

        downloadFromURL(urlStr, "Revenue", "csv");
      } catch (error) {
        console.error(`Error in downloadCSV `, error);
      }
    },
    getURLString(baseURL, payload) {
      let urlKeyValuePairs = [];

      for (let key in payload) {
        urlKeyValuePairs.push(`${key}=${payload[key]}`);
      }

      return baseURL + "&" + urlKeyValuePairs.join("&");
    },
    async getAllRevenueData() {
      this.selectedRevenueItems = [];
      this.revenueDataList = [];
      this.revenueDataListAll = [];
      this.optionTempTerritory = [];
      this.optionTempRights = [];

      try {
        let payload = {
          invoice_number:
            this.$props && this.$props.invNumber ? this.$props.invNumber : null,
          vendor_id: this.selectedCustomer
            ? this.selectedCustomer.vendor_id
            : "",
          rightType: this.selectedRight ? this.selectedRight.value : "",
          billedStatus: this.selectedStatus ? this.selectedStatus.value : "",

          start_date: this.revenueDateRange
            ? this.revenueDateRange.split("to")[0]
            : "",
          end_date: this.revenueDateRange
            ? this.revenueDateRange.split("to")[1]
            : "",
          search: this.search,
          limit: this.limit,
          page: this.currentPage,
          movie_id:
            this.filterTempMovie && this.filterTempMovie.id
              ? this.filterTempMovie.id
              : null,
          subRights: this.subRights,
          relevant_for_royalty: this.selectedRelevance,
          show_deleted: this.showDeletedRevenues,
        };
        const response = await GetVendorRevenueData(payload);
        if (response.data.status) {
          this.revenueDataListAll = response.data.data.data;
          this.revenueDataList = response.data.data.data;
          this.itemsInRow = this.revenueDataList.length;
          if (
            response.data.data.pagination &&
            response.data.data.pagination.total
          ) {
            this.totalRows = response.data.data.pagination.total;
          }
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      }
    },

    onFilterChange() {
      this.savePaginationAndFilters();
    },

    async GetAllVendor() {
      try {
        const response = await getAllVendor({});
        if (response.data) {
          this.optionCustomer = response.data.data.data;
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      }
    },

    async GetAllMovie(searchTerm) {
      // this.optionTempMovie = [];
      //this.debouncdFetchMovies is used to avoid multiple api fetching
      // if (!this._debouncedFetchMovies) {
      //   this._debouncedFetchMovies = debounce(async (searchTerm) => {
      try {
        // {limit:50,search:searchTerm}
        const payload = {};
        const response = await getAllMovie();
        if (response.data) {
          this.optionTempMovie = response.data.data.data;
          console.log(this.optionTempMovie, "dad");
        }
      } catch (err) {
        console.log("Error in getting movies list ", err);
      }
      //   });
      // }
      // this._debouncedFetchMovies(searchTerm);
    },

    savePaginationAndFilters() {
      console.log(this.trl_rights);
      if (this.subRights) {
        this.trl_rights.forEach((right) => {
          if (this.subRights.includes(right.id)) {
            const childrenIds = right.children.map((child) => child.id);
            this.subRights = [...new Set([...this.subRights, ...childrenIds])];
          }
        });
      }
      localStorage.setItem(
        "viewAddedRevenuePageFiltersAndPagination",
        JSON.stringify({
          filterTempMovie: this.filterTempMovie,
          selectedCustomer: this.selectedCustomer,
          subRights: this.subRights,
          selectedRight: this.selectedRight,
          selectedStatus: this.selectedStatus,
          revenueDateRange: this.revenueDateRange,
          subRightsChildren: this.subsRightsChildren,
          selectedRelevance: this.selectedRelevance,
        })
      );
    },

    async deleteRevenueById(data, id, type) {
      const response = await DeleteRevenueById({
        revenue_data_id: id,
        type: type,
        data: data,
        setPaymentDate: this.setPaymentDate,
      });
      if (response.data.status) {
        this.getAllRevenueData();
        return this.$toast({
          component: ToastificationContentVue,
          props: {
            title: response.data.message || "Deleted Successfully",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      return this.$toast({
        component: ToastificationContentVue,
        props: {
          title: response.data.message || "Delete Failed",
          icon: "EditIcon",
          variant: "danger",
        },
      });
    },
    showDeleteConfirm(data, type) {
      this.$bvModal
        .msgBoxConfirm(
          type == "delete"
            ? "Are you sure, you want to delete?"
            : "Are you sure, you want to Update Payment Dates?",
          {
            title: "Confirmation",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true)
            this.deleteRevenueById(data, data.revenue_data_id, type);
        })
        .catch((err) => {
          // An error occurred
        });
    },
    hideShowFilter() {
      this.filtersHidden = !this.filtersHidden;
    },
    onPageChange() {
      this.$nextTick(() => {
        this.getAllRevenueData();
      });
    },
    async onSearch() {
      this.setIsInvoice = false;
      this.currentPage = 1;
      this.getAllRevenueData();
      this.onFilterChange();
    },
    async resetForm() {
      this.selectedCustomer = null;
      this.selectedRight = null;
      this.selectedStatus = null;
      this.revenueDateRange = null;
      this.subRights = null;
      this.filterTempMovie = null;
      this.currentPage = 1;
      this.savePaginationAndFilters();
      this.getAllRevenueData();
      this.selectedRelevance = 1;
    },

    async loadAllRevenueData() {
      const filtersAndPaginationOfRevenueData = localStorage.getItem(
        "viewAddedRevenuePageFiltersAndPagination"
      );
      if (filtersAndPaginationOfRevenueData) {
        const obj = JSON.parse(filtersAndPaginationOfRevenueData);
        this.filterTempMovie = obj.filterTempMovie;
        (this.selectedCustomer = obj.selectedCustomer),
          (this.subRights = obj.subRights),
          (this.selectedRight = obj.selectedRight),
          (this.selectedStatus = obj.selectedStatus),
          (this.revenueDateRange = obj.revenueDateRange),
          (this.selectedRelevance = obj.selectedRelevance);
        this.$forceUpdate();
      }
      this.getAllRevenueData();
    },

    async getAllRights() {
      try {
        const payload = {
          list_route: `right-tree`,
        };
        const response = await MasterServices.getMasterList(payload);
        if (response) {
          console.log(response.data);
          this.trl_rights = response.data.data;
        }
      } catch (err) {
        console.log("Error in getting rigths list ", err);
      }
    },

    toggleSetPaymentDate() {
      // alert(this.setPaymentDate);
      if (this.setPaymentDate == true) {
        this.setPaymentDate = false;
      } else {
        this.setPaymentDate = true;
      }
      this.setPaymentDate = !this.setPaymentDate;
      // alert(this.setPaymentDate);
    },


async handle_revert(data) {
  console.log(data, "data in handle_revert");
  try {
    console.log("Reverting item:", data);
    let response;

    if (!data || typeof data !== "object") {
      console.warn("Invalid data object passed to handle_revert");
      return;
    }

    if (data.revenue_data_id) {
      const { revenue_data_id } = data;

      const payload = { revenue_data_id };
      response = await RevenueServices.revert_revenue(payload);

    } else {
      const { revenue_expense_id } = data;
      if (!revenue_expense_id) {
        console.warn("Missing revenue_expense_id");
        return;
      }

      const payload = { revenue_expense_id };
      response = await RevenueServices.revert_expense(payload);
    }

    if (response?.data?.status) {
      this.$toast({
        component: ToastificationContentVue,
        props: {
          title: response.data.message || "Success",
          icon: "EditIcon",
          variant: "success",
        },
      });
      this.$emit("modal-cancel");
      this.getAllRevenueData();
    } else {
      this.$toast({
        component: ToastificationContentVue,
        props: {
          title: "Migration failed: " + (response?.data?.message || "Unknown error"),
          icon: "EditIcon",
          variant: "danger",
        },
      });
    }
  } catch (error) {
    console.error("Error during Reverting Revenue:", error);
  }
}


  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
